
const digest = 'd6443e9a2b5ce000cd6591e373f95d9fb6adcc169cdf210a7a7b20bda30b398b';
const classes = {"wrapper":"_wrapper_4gqg2_1","list":"_list_4gqg2_10","scrollContainer":"_scrollContainer_4gqg2_17","flatList":"_flatList_4gqg2_22","detail":"_detail_4gqg2_27"};
const css = `._wrapper_4gqg2_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  height: 100%;
  border-top: 1px solid #eaedf3;
  border-right: 1px solid #eaedf3;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_4gqg2_1 ._list_4gqg2_10 {
  width: 300px;
  border-right: 1px solid #eaedf3;
  padding: 10px;
  overflow-y: hidden;
  height: 100%;
}
._wrapper_4gqg2_1 ._list_4gqg2_10 ._scrollContainer_4gqg2_17 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_4gqg2_1 ._list_4gqg2_10 ._flatList_4gqg2_22 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
._wrapper_4gqg2_1 ._detail_4gqg2_27 {
  flex-grow: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  